import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Popover, Card } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import { fetchGetAllApps } from 'services/auth';
import { PopUpLista } from './PopUpLista';
import * as S from './styles';

export const SistemasSefaz = () => {
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const systems = useSelector(state => state.sefaz?.allSystems);
  const unitaryTests = useSelector(state => state.app.unitaryTests);

  useEffect(() => {
    if (unitaryTests) return;
    if (user) dispatch(fetchGetAllApps(systems));
    // eslint-disable-next-line
  }, [dispatch, user, unitaryTests]);

  const getSystem = () => {
    if (!systems) {
      if (user) dispatch(fetchGetAllApps(systems));
    }
  };

  const contentSistemas = () => {
    return (
      <Card bordered={false}>
        {systems?.length > 0 ? <PopUpLista /> : <p>Não foi possível carregar os serviços.</p>}
      </Card>
    );
  };

  return (
    <div>
      <Popover placement="bottom" content={contentSistemas} trigger="click">
        <S.ContainerIcon>
          <S.IconButton onClick={() => getSystem()}>
            <AppstoreOutlined style={{ color: 'var(--bottom-color-sefaz)' }} />
          </S.IconButton>
        </S.ContainerIcon>
      </Popover>
    </div>
  );
};
export default SistemasSefaz;
